/**
 * @file Newsletter
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Newsletter component
 */
const vNewsletter = () => {
	const newsletter = document.querySelector( '.v-newsletter' );

	if ( ! newsletter ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const inner       = newsletter.querySelector( '.v-newsletter__inner' );
	const form        = newsletter.querySelector( '.v-newsletter__form' );
	const spinner     = newsletter.querySelector( '.v-newsletter__loading' );
	const innerFrom   = { opacity: 0 };
	const innerTo     = {
		opacity:  1,
		duration: 1,
		ease:     'ease.inOut',
	};
	const triggerVars = {
		trigger:       inner,
		toggleActions: 'play none none reset',
	};

	// const e = `<script src="${ form.dataset.formEndpoint }"></script>`;

	/**
	 * remove imported script styles
	 */
	const removeStyles = () => {
		const styles = document.querySelectorAll( 'link[rel="stylesheet"][href^="//static.formstack.com"], .v-newsletter style[type="text/css"]' );
		for ( let i = 0; i < styles.length; i++ ) {
			styles[ i ].parentNode.removeChild( styles[ i ] );
		}
	};

	/**
	 * Style checkbox input
	 */
	const styleCheckbox = () => {
		const checkbox       = document.querySelector( '.v-newsletter input[type="checkbox"]' );
		const checkboxParent = checkbox.parentNode;

		// Only if checkbox hasn't already been styled
		if ( checkboxParent.classList.contains( 'v-form__checkbox-label' ) ) {
			return;
		}

		const box  = document.createElement( 'span' );
		const text = document.createElement( 'span' );
		box.classList.add( 'v-form__checkbox' );
		text.classList.add( 'v-form__checkbox-text' );
		checkboxParent.insertBefore( box, checkbox.nextSibling );
		checkbox.classList.add( 'v-form__checkbox-original' );

		const oldText = checkboxParent.removeChild( box.nextSibling );
		text.appendChild( oldText );
		checkboxParent.appendChild( text );
		checkboxParent.classList.add( 'v-form__checkbox-label' );
	};

	/**
	 * Style inputs
	 */
	const styleInputs = () => {
		const inputs = document.querySelectorAll( '#field113069145-first, #field113069145-last, #field113069151' );

		[ ...inputs ].forEach( ( i ) => {
			if ( i.classList.contains( 'v-newsletter__input--styled' ) ) {
				return;
			}

			const label = i.parentElement.querySelector( 'label' );
			label.classList.add( 'v-newsletter__label' );
			i.classList.add( 'v-newsletter__input--styled' );

			i.addEventListener( 'focusin', () => {
				label.classList.add( 'v-newsletter__label--hide' );
			} );

			i.addEventListener( 'focusout', () => {
				if ( i.value ) {
					return;
				}

				label.classList.remove( 'v-newsletter__label--hide' );
			} );
		} );
	};

	/**
	 * Style submit button
	 */
	const styleSubmit = () => {
		const submitBtn    = document.querySelector( '#fsSubmitButton4464515' );
		const submitParent = submitBtn.parentNode;
		if ( submitBtn.classList.contains( '.v-button' ) ) {
			return;
		}

		const wrap      = document.createElement( 'span' );
		wrap.classList.add( 'v-newsletter__form-submit-wrap' );
		submitBtn.classList.add( 'v-button' );
		submitBtn.classList.add( 'v-newsletter__submit' );
		submitBtn.value = 'Sign Up';
		submitBtn.removeAttribute( 'style' );
		wrap.appendChild( submitBtn );
		submitParent.appendChild( wrap );
	};

	/**
	 * Edit label text content
	 */
	const editCheckboxLabel = () => {
		const box            = document.querySelector( '.fsOptionLabel .v-form__checkbox' );
		const checkboxParent = box.parentElement;
		const textNode       = box.nextSibling;
		const newText        = document.createElement( 'span' );
		newText.classList.add( 'v-form__checkbox-text' );
		newText.textContent  = 'I would like to be contacted about donation options.';
		checkboxParent.removeChild( textNode );
		checkboxParent.appendChild( newText );
	};

	/**
	 * Runs when newsletter form is loaded.
	 */
	const afterFormLoad = () => {
		removeStyles(); // remove imported styles
		styleCheckbox(); // style checkbox
		styleInputs(); // style input focus states
		styleSubmit(); // style submit btn
		editCheckboxLabel();

		spinner.classList.add( 'v-newsletter__loading--hidden' );
		ScrollTrigger.refresh();
		form.setAttribute( 'data-form-loaded', '' );
		setTimeout( () => {
			form.removeAttribute( 'style' );
			ScrollTrigger.refresh();
		}, 250 );
	};

	/* if ( ! form.hasAttribute( 'data-form-loaded' ) ) {
		postscribe( form, e, {
			afterDequeue: () => {
				form.style.opacity = 0;
			},
			done: () => {
				removeStyles(); // remove imported styles
				styleCheckbox(); // style checkbox
				styleInputs(); // style input focus states
				styleSubmit(); // style submit btn
				editCheckboxLabel();

				spinner.classList.add( 'v-newsletter__loading--hidden' );
				ScrollTrigger.refresh();
				form.setAttribute( 'data-form-loaded', '' );
				setTimeout( () => {
					form.removeAttribute( 'style' );
				}, 250 );
			},
		} );
	} */

	if ( document.querySelector( '.fsForm input' ) ) {
		afterFormLoad();
	} else {
		const formConfig   = {
			childList: true,
		};

		/**
		 * Callback for Newsletter signup mutation observer
		 */
		const newsletterFormCb = () => {
			const field = form.querySelector( 'input' );
			if ( field ) {
				afterFormLoad();
				formObserver.disconnect();
			}
		};

		const formObserver = new MutationObserver( newsletterFormCb );
		formObserver.observe( form, formConfig );
	}

	gsap.fromTo( inner, innerFrom, {
		scrollTrigger: {
			start: 'top bottom-=10%',
			...triggerVars,
		},
		...innerTo,
	} );
};

export default vNewsletter;
